import { render } from "./Comiss.vue?vue&type=template&id=ad9feb98&scoped=true"
import script from "./Comiss.vue?vue&type=script&lang=js"
export * from "./Comiss.vue?vue&type=script&lang=js"

import "./Comiss.vue?vue&type=style&index=0&id=ad9feb98&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad9feb98"]])

export default __exports__